import React, {ChangeEvent, useEffect, useState} from 'react';
import {Button, message} from 'antd';

import ParcelsDownloadModal from "./ParcelsDownloadModal";
import {useMutation, useQuery} from '@apollo/client';
import {getUserInfo} from "../../../../utils/auth";
import {GET_ALL_SETTLEMENT_CLIENT_FOR_OPTIONS, AllSettlementClientResponse} from '../graphql/queries/getAllSettlementClient';
import { GET_FEE_ITEM_LIST_FOR_OPTIONS, AllFeeItemResponse} from '../graphql/queries/getAllFeeItem';
import { CREATE_VOUCHER_CLEARING_DOWNLOAD_TASK, VoucherClearingDownloadTaskResponse } from '../graphql/mutations/createVoucherClearingDownloadTask';
import InputFilterItem from "../../../delivery/components/InputFilterItem";
import BatchInputFilterItem from "../../../delivery/components/BatchInputFilterItem";
import { VoucherClearingLogFilterType, VoucherClearingLogType } from '../graphql/types/VoucherClearingLogType';
import DateRangeFilterItem from "../../../delivery/components/DateRangeFilterItem";
import {formatTimeRangeToISO} from "../../../../utils/dateTimeUtils";

interface VoucherClearingFilterProps {
    filters: VoucherClearingLogFilterType;
    setFilters: (filters: VoucherClearingLogFilterType) => void;
    handleFilter: () => void;
    handleResetFilters: () => void;
}

const VoucherClearingFilter: React.FC<VoucherClearingFilterProps> = ({
                                                       filters,
                                                       setFilters,
                                                       handleFilter,
                                                       handleResetFilters
                                                   }) => {
    const userRole = getUserInfo()?.account?.role?.name || '';

    const handleSettlementTimeChange = (
        dates: [string | null, string | null] | null
    ) => {
        setFilters({...filters, createdAt: dates});
    };

    return (
        <div className="mb-6">
            <div className="mb-4">
                <BatchInputFilterItem
                    label="Tracking"
                    value={filters.businessId || ''}
                    onChange={(e: ChangeEvent<HTMLTextAreaElement>) => setFilters({
                        ...filters,
                        businessId: e.target.value || undefined
                    })}
                    spanClassName="w-[9em]"
                    rows={2}
                />
            </div>
            <div className="grid grid-cols-3 gap-x-4 gap-y-3 mb-4">
                <InputFilterItem
                    label="清分ID"
                    value={filters.clearingId || ''}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({...filters, clearingId: e.target.value || undefined})}
                    spanClassName="w-[9em]"
                />
                 <InputFilterItem
                    label="任务ID"
                    value={filters.reRunTaskId || ''}
                    onChange={(e: ChangeEvent<HTMLInputElement>) => setFilters({...filters, reRunTaskId: e.target.value || undefined})}
                    spanClassName="w-[9em]"
                />
                <DateRangeFilterItem
                    label="创建时间"
                    value={filters.createdAt || null}
                    onChange={handleSettlementTimeChange}
                    spanClassName="w-[9em]"
                />
            </div>
            <div className="mb-4 flex justify-between">
                <div className="space-x-4">
                    <Button type="primary" onClick={handleFilter}>
                        Filter
                    </Button>
                    <Button onClick={handleResetFilters}>
                        Reset
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default VoucherClearingFilter;